import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { Country, State } from 'country-state-city';
import config from '../../../config/config'
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2'; // Import SweetAlert2
import Dropzone from 'react-dropzone';


function AddUpdateProperty(props) {
    const rawParams = useParams();
    const id = rawParams.id ?? '0'; // or Number(rawParams.id ?? 0);
    const navigate = useNavigate();
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);;
    // const [fileName, setFileName] = useState('');
    const [fileNames, setFileNames] = useState([]);
    const userId = localStorage.getItem("userId");
      const userType = localStorage.getItem("userType");
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        country: '',
        state: '',
        pincode: '',
        address: '',
        // image: '',
        image: [],
        userType:userType,
        userId: userId,
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        setCountries(Country.getAllCountries());
        if (id) {
            config.getPropertyById({ id }).then((response) => {
                const res = response.data;

                // Set states for the selected country
                if (res.country) {
                    const statesList = State.getStatesOfCountry(res.country);
                    setStates(statesList);
                }

                // Update form data
                setFormData({
                    name: res.name || '',
                    phone: res.phone || '',
                    email: res.email || '',
                    country: res.country || '',
                    state: res.state || '',
                    pincode: res.pincode || '',
                    address: res.address || '',
                    userType: userType,
                    userId:userId,
                    image: res.image ? res.image.split(',') : [],
                });
                // setFileName(res.image || '');
                setFileNames(res.image ? res.image.split(',') : []);
            }).catch((error) => {
                console.error('Error fetching user:', error);
            });
        }
    }, []);
    ;
    const handleCountryChange = (e) => {
        const countryCode = e.target.value;
        setFormData({ ...formData, country: countryCode, state: '' });
        setStates(State.getStatesOfCountry(countryCode));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.name.trim()) newErrors.name = 'Name is required';
        if (!formData.phone.trim()) newErrors.phone = 'Phone is required';
        if (!formData.email.trim()) newErrors.email = 'Email is required';
        if (!formData.country) newErrors.country = 'Country is required';
        if (!formData.state) newErrors.state = 'State is required';
        if (!formData.pincode.trim()) newErrors.pincode = 'Pincode is required';
        if (!formData.address.trim()) newErrors.address = 'Address is required';
        if (!formData.image || (Array.isArray(formData.image) && formData.image.length === 0)) newErrors.image = 'Image is required';
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            Swal.fire('Validation Error', 'Please correct the highlighted fields.', 'warning');
            return;
        }

        const formPayload = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
            if (key === 'image') {
                if (Array.isArray(value)) {
                    // join into comma separated string for backend compatibility
                    formPayload.append('image', value.join(','));
                } else {
                    formPayload.append('image', value || '');
                }
            } else {
                formPayload.append(key, value ?? '');
            }
        });

        // if (fileName) {
        //     formPayload.append("image", fileName);
        // }
console.log("formPayload",formPayload);
// return;
        try {
            // Log FormData entries for debugging
            for (let pair of formPayload.entries()) {
                console.log('FormData entry:', pair[0], pair[1]);
            }

            let response;
            if (id !== '0') {
                formPayload.append("id", id);
                response = await config.createProperty(formPayload); // Update
            } else {
                response = await config.createProperty(formPayload); // Add
            }

            console.log('createProperty response:', response);

            Swal.fire({ text: response.data.message || 'Success!', icon: response.data.icon })
                .then((result) => {
                    if (result.isConfirmed) navigate(-1);
                });

            if (id === '0') {
                setFormData({ name: '', phone: '', email: '', country: '', state: '', pincode: '', address: '', image: [] });
                setFileNames([]);
                setStates([]);
            }

        } catch (error) {
            const msg = error.response?.data?.message || 'Something went wrong!';
            Swal.fire({ text: msg, icon: 'error' }).then(() => navigate(-1));
        }
    };
    const handleFileUpload = async (acceptedFiles) => {
        if (!acceptedFiles.length) return;

        const newFileNames = [...fileNames];

        for (let file of acceptedFiles) {
            const dropZoneData = new FormData();
            dropZoneData.append('file', file);

            try {
                const res = await config.propertyImageUpload(dropZoneData);
                console.log('propertyImageUpload response:', res);
                // accept multiple possible filename shapes from server
                const filename = res?.data?.filename ?? res?.data?.fileName ?? res?.data?.data?.filename ?? null;
                if (filename) {
                    newFileNames.push(filename);
                } else {
                    console.error('Upload did not return a filename:', res);
                    Swal.fire('Upload Error', 'Server did not return uploaded filename.', 'error');
                }
            } catch (error) {
                console.error('Upload error:', error);
                Swal.fire('Error', 'Failed to upload one or more files.', 'error');
            }
        }

        setFileNames(newFileNames);
        console.log("new",newFileNames);
        
        setFormData(prev => ({
            ...prev,
            image: newFileNames,
        }));
    };

    const handleRemoveImage = (idx) => {
        const updatedFileNames = fileNames.filter((_, i) => i !== idx);
        setFileNames(updatedFileNames);
        
        setFormData((prev) => ({
            ...prev,
            image: updatedFileNames,
        }));
    };




    return (
        <div className='page-inner'>
            <div className="page-header">
                <h3 className="fw-bold mb-3">Add</h3>
                <ul className="breadcrumbs mb-3">
                    <li className="nav-home">
                        <a href="#"><i className="fas fa-home"></i></a>
                    </li>
                    <li className="separator"><i className="fa-solid fa-greater-than"></i></li>
                    <li className="nav-item"><a href="#">List</a></li>
                    <li className="separator"><i className="fa-solid fa-greater-than"></i></li>
                    <li className="nav-item"><a href="#">Add</a></li>
                </ul>
            </div>

            <div className='row'>
                <div className='col-md-12'>
                    <div className='card'>
                        <div className='card-header'>
                            <div className='card-title'>Property Details</div>
                        </div>
                        <div className='card-body'>
                            <Form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-xl-4 mb-3">
                                        <Form.Group controlId="name">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                isInvalid={!!errors.name}
                                                placeholder="Enter Name"
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    <div className="col-xl-4 mb-3">
                                        <Form.Group controlId="phone">
                                            <Form.Label>Phone</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                isInvalid={!!errors.phone}
                                                placeholder="Enter Phone"
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.phone}</Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    <div className="col-xl-4 mb-3">
                                        <Form.Group controlId="email">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                isInvalid={!!errors.email}
                                                placeholder="Enter Email"
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-xl-4 mb-3">
                                        <Form.Group>
                                            <Form.Label>Country</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="country"
                                                value={formData.country}
                                                onChange={handleCountryChange}
                                                isInvalid={!!errors.country}
                                            >
                                                <option value="">-- Select Country --</option>
                                                {countries.map((country) => (
                                                    <option key={country.isoCode} value={country.isoCode}>{country.name}</option>
                                                ))}
                                            </Form.Control>
                                            <Form.Control.Feedback type="invalid">{errors.country}</Form.Control.Feedback>
                                        </Form.Group>
                                    </div>

                                    <div className="col-xl-4 mb-3">
                                        <Form.Group>
                                            <Form.Label>State</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="state"
                                                value={formData.state}
                                                onChange={handleChange}
                                                isInvalid={!!errors.state}
                                                disabled={!formData.country}
                                            >
                                                <option value="">-- Select State --</option>
                                                {states.map((state) => (
                                                    <option key={state.isoCode} value={state.isoCode}>{state.name}</option>
                                                ))}
                                            </Form.Control>
                                            <Form.Control.Feedback type="invalid">{errors.state}</Form.Control.Feedback>
                                        </Form.Group>
                                    </div>

                                    <div className="col-xl-4 mb-3">
                                        <Form.Group controlId="pincode">
                                            <Form.Label>Pincode</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="pincode"
                                                value={formData.pincode}
                                                onChange={handleChange}
                                                isInvalid={!!errors.pincode}
                                                placeholder="Enter Pincode"
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.pincode}</Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-xl-4 mb-3">
                                        <Form.Group controlId="address">
                                            <Form.Label>Address</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={2}
                                                name="address"
                                                value={formData.address}
                                                onChange={handleChange}
                                                isInvalid={!!errors.address}
                                                placeholder="Enter Address"
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.address}</Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-4 mb-3">
                                        <Form.Group>
                                            <Form.Label>Upload File</Form.Label>

                                            <Dropzone onDrop={handleFileUpload} multiple>
                                                {({ getRootProps, getInputProps }) => (
                                                    <div {...getRootProps()} className="dropzone border p-3 rounded text-center" style={{ cursor: 'pointer' }}>
                                                        <input {...getInputProps()} />
                                                        <p>Drag & drop files here, or click to select</p>

                                                        <div className="d-flex flex-wrap justify-content-start mt-2 gap-2">
                                                            {fileNames.map((file, idx) => (
                                                                <div key={idx} className="position-relative">
                                                                    <img
                                                                        src={`${config.IMAGE_URL}property/${file}`}
                                                                        alt={`preview-${idx}`}
                                                                        style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '4px' }}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => handleRemoveImage(idx)}
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: '-8px',
                                                                            right: '-8px',
                                                                            backgroundColor: 'red',
                                                                            color: 'white',
                                                                            border: 'none',
                                                                            borderRadius: '50%',
                                                                            width: '24px',
                                                                            height: '24px',
                                                                            padding: 0,
                                                                            cursor: 'pointer',
                                                                            fontSize: '16px',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center'
                                                                        }}
                                                                        title="Remove image"
                                                                    >
                                                                        ×
                                                                    </button>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </Dropzone>


                                            {errors.image && (
                                                <div className="text-danger mt-1">{errors.image}</div>
                                            )}

                                        </Form.Group>
                                    </div>
                                </div>

                                <div className="card-action d-flex gap-2">
                                    <button type="submit" className="btn btn-success">Submit</button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => navigate(-1)}
                                    >
                                        Back
                                    </button>

                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddUpdateProperty;
